<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row" [class.invalid]="!isValid() && control?.dirty">
  <input
    type="text"
    class="flex fs14"
    [(ngModel)]="date"
    (ngModelChange)="valueChanged()"
    [min]="minDate"
    [max]="maxDate"
    [placeholder]="placeholder"
    [imask]="mask"
    [unmask]="true"
  />
  <div class="flex flex-row flex-nosize ml10">
    <label class="flex" [class.required]="isRequired">
      <ng-container *ngIf="keepPlaceholder">
        {{ placeholder }}
      </ng-container>
    </label>
  </div>
  <!--    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
  <!--    <mat-datepicker #picker disabled="false" color="accent"></mat-datepicker>-->
</div>
